<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path stroke="currentColor" stroke-width="2" d="M3.5 4.5h17v15h-17zM6.5 11h7M6.5 15h11" /></svg
>
